var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33398 0C3.7817 0 3.33398 0.447714 3.33398 0.999999V39C3.33398 39.5523 3.7817 40 4.33398 40H35.6673C36.2196 40 36.6673 39.5523 36.6673 39V6.66667L30.0007 0H4.33398Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.001 0V6.66667H36.6676L30.001 0Z",
    fill: "#F4F4F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.66699,
    y: 18,
    width: 36.6667,
    height: 10,
    rx: 1,
    fill: "#E60000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7575 26V20.1818H14.9393C15.3862 20.1818 15.7612 20.2652 16.0643 20.4318C16.3692 20.5985 16.5993 20.8277 16.7546 21.1193C16.9118 21.4091 16.9904 21.7386 16.9904 22.108C16.9904 22.4811 16.9118 22.8125 16.7546 23.1023C16.5974 23.392 16.3654 23.6203 16.0586 23.7869C15.7518 23.9517 15.3739 24.0341 14.9251 24.0341H13.479V23.1676H14.783C15.0444 23.1676 15.2584 23.1222 15.4251 23.0312C15.5917 22.9403 15.7148 22.8153 15.7944 22.6562C15.8758 22.4972 15.9165 22.3144 15.9165 22.108C15.9165 21.9015 15.8758 21.7197 15.7944 21.5625C15.7148 21.4053 15.5908 21.2831 15.4222 21.196C15.2556 21.107 15.0406 21.0625 14.7773 21.0625H13.8114V26H12.7575ZM19.8775 26H17.9059V20.1818H19.9173C20.4949 20.1818 20.9911 20.2983 21.4059 20.5312C21.8226 20.7623 22.1426 21.0947 22.3661 21.5284C22.5896 21.9621 22.7013 22.4811 22.7013 23.0852C22.7013 23.6913 22.5887 24.2121 22.3633 24.6477C22.1398 25.0833 21.8169 25.4176 21.3945 25.6506C20.9741 25.8835 20.4684 26 19.8775 26ZM18.9599 25.0881H19.8263C20.2317 25.0881 20.5697 25.0142 20.8406 24.8665C21.1114 24.7169 21.315 24.4943 21.4513 24.1989C21.5877 23.9015 21.6559 23.5303 21.6559 23.0852C21.6559 22.6402 21.5877 22.2708 21.4513 21.9773C21.315 21.6818 21.1133 21.4612 20.8462 21.3153C20.5811 21.1676 20.2515 21.0938 19.8576 21.0938H18.9599V25.0881ZM23.7028 26V20.1818H27.43V21.0653H24.7567V22.6449H27.1744V23.5284H24.7567V26H23.7028Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.746e7984945f75a4a9e8371e2577cd7b.svg";
export { ForwardRef as ReactComponent };